<script>
	// NPM Modules
	import dayjs from 'dayjs';
	import localizedFormat from 'dayjs/plugin/localizedFormat';
	// Services
	import { CurrencyFormat } from '@/Services/Helpers.js';
	import { NumberFormat } from '@/Services/Helpers.js';

	dayjs.extend(localizedFormat);

	export let user;
</script>

{#if user && user.real_client_value}
	<div class="flex flex-col md:w-1/2 text-dark-grey bg-gray-50 min-h-48">
		<div class="flex items-center px-2 bg-dark-grey text-light">
			<h2 class="flex-1 py-2 text-xl italic font-sans-condensed">Estimated Real Client Value</h2>
		</div>
		<div class="overflow-auto">
			<table class="table w-full overflow-y-auto bg-white">
				<tr class="text-sm text-left bg-grey text-light">
					<th class="py-2 pl-2" />
					{#each Object.keys(user.real_client_value) as timeperiod}
						{#if user.real_client_value[timeperiod].label !== null && user.real_client_value[timeperiod].label !== undefined}
							<th class="py-2 italic w-28 text-nowrap px-1 md:px-0">{user.real_client_value[timeperiod].label}</th>
						{:else if user.real_client_value[timeperiod].start_date == null && user.real_client_value[timeperiod].end_date == null}
							<th class="py-2 italic w-28 text-nowrap px-1 md:px-0">Lifetime</th>
						{:else if user.real_client_value[timeperiod].start_date != null && user.real_client_value[timeperiod].end_date == null && dayjs(user.real_client_value[timeperiod].start_date).format('MMM') !== dayjs().format('MMM')}
							<th class="py-2 italic w-28 text-nowrap px-1 md:px-0"
								>Since {dayjs(user.real_client_value[timeperiod].start_date).format('DD-MM-YYYY')}</th
							>
						{:else if user.real_client_value[timeperiod].start_date != null && user.real_client_value[timeperiod].end_date == null && dayjs(user.real_client_value[timeperiod].start_date).format('MMM') == dayjs().format('MMM')}
							<th class="py-2 italic w-28 text-nowrap px-1 md:px-0">MTD</th>
						{:else if dayjs(user.real_client_value[timeperiod].start_date).format('MMM') !== dayjs(user.real_client_value[timeperiod].end_date).format('MMM') && user.real_client_value[timeperiod].end_date !== null && user.real_client_value[timeperiod].start_date !== null}
							<th class="py-2 italic w-28 text-nowrap px-1 md:px-0"
								>{dayjs(user.real_client_value[timeperiod].start_date).format('MMM')} - {dayjs(
									user.real_client_value[timeperiod].end_date
								).format('MMM')}</th
							>
						{:else if dayjs(user.real_client_value[timeperiod].start_date).format('MMM') == dayjs(user.real_client_value[timeperiod].end_date).format('MMM')}
							<th class="py-2 italic w-28 text-nowrap px-1 md:px-0"
								>{dayjs(user.real_client_value[timeperiod].start_date).format('MMMM')}</th
							>
						{/if}
					{/each}
				</tr>
				<tr class="text-sm text-center bg-gray-100 italic">
					<td class="py-1 text-left border-b pl-2 font-semibold text-base text-nowrap"> Cash Turnover </td>
					{#each Object.keys(user.real_client_value) as timeperiod}
						<td class="py-1 text-left border-b"
							>{CurrencyFormat(user.real_client_value[timeperiod].cash_turnover, false, true, true)}</td
						>
					{/each}
				</tr>
				<tr class="text-sm text-center bg-gray-100 italic">
					<td class="py-1 text-left border-b pl-2 font-semibold text-base text-nowrap"> Gross Win </td>
					{#each Object.keys(user.real_client_value) as timeperiod}
						<td class="py-1 text-left border-b"
							>{CurrencyFormat(user.real_client_value[timeperiod].gross_win_amount, false, true, true)}</td
						>
					{/each}
				</tr>
				<tr class="text-sm text-center bg-gray-100 italic">
					<td class="py-1 text-left border-b pl-2 font-semibold text-base text-nowrap"> Bonus cost </td>
					{#each Object.keys(user.real_client_value) as timeperiod}
						<td class="py-1 text-left border-b"
							>{CurrencyFormat(user.real_client_value[timeperiod].bonus_win_amount, false, true, true)}</td
						>
					{/each}
				</tr>
				<tr class="text-sm text-center bg-gray-100 italic">
					<td class="py-1 text-left border-b pl-2 font-semibold text-base text-nowrap"> Total Bonus cost </td>
					{#each Object.keys(user.real_client_value) as timeperiod}
						<td class="py-1 text-left border-b"
							>{CurrencyFormat(
								parseFloat(user.real_client_value[timeperiod].bonus_win_amount) +
									parseFloat(user.real_client_value[timeperiod].boosted_amount),
								false,
								true,
								true
							)}</td
						>
					{/each}
				</tr>
				<tr class="text-sm text-center bg-gray-100 border-b-2 border-black italic">
					<td class="py-1 text-left border-b pl-2 font-semibold text-base text-nowrap"> Net Win </td>
					{#each Object.keys(user.real_client_value) as timeperiod}
						<td class="py-1 text-left border-b"
							>{CurrencyFormat(user.real_client_value[timeperiod].net_win, false, true, true)}</td
						>
					{/each}
				</tr>
				<tr class="text-sm text-center">
					<td class="py-1 text-left border-b pl-2 font-semibold text-base italic text-nowrap"> Taxes </td>
					{#each Object.keys(user.real_client_value) as timeperiod}
						<td class="py-1 text-left border-b"
							>{CurrencyFormat(user.real_client_value[timeperiod].taxes, false, true, true)}</td
						>
					{/each}
				</tr>
				<tr class="text-sm text-center">
					<td class="py-1 text-left border-b pl-2 font-semibold text-base italic text-nowrap"> Fees </td>
					{#each Object.keys(user.real_client_value) as timeperiod}
						<td class="py-1 text-left border-b"
							>{CurrencyFormat(
								parseFloat(user.real_client_value[timeperiod].fees) +
									parseFloat(user.real_client_value[timeperiod].costs) +
									parseFloat(user.real_client_value[timeperiod].product_fees),
								false,
								true,
								true
							)}</td
						>
					{/each}
				</tr>
				<tr class="text-sm text-center bg-gray-100 border-t-2 border-black italic">
					<td class="py-1 text-left border-b pl-2 font-semibold text-base text-nowrap"> Real Net Win </td>
					{#each Object.keys(user.real_client_value) as timeperiod}
						<td
							class="py-1 text-left border-b"
							class:text-red-500={user.real_client_value[timeperiod].real_net_win < 0}
							class:text-green-500={user.real_client_value[timeperiod].real_net_win >= 0}
							>{CurrencyFormat(user.real_client_value[timeperiod].real_net_win, false, true, true)}</td
						>
					{/each}
				</tr>
				<tr class="text-sm text-center bg-gray-100 border-b-2 border-black italic">
					<td class="py-1 text-left border-b pl-2 font-semibold text-base text-nowrap"> Real Net Win % </td>
					{#each Object.keys(user.real_client_value) as timeperiod}
						<td
							class="py-1 text-left border-b"
							class:text-red-500={user.real_client_value[timeperiod].real_net_win_percent < 0}
							class:text-green-500={user.real_client_value[timeperiod].real_net_win_percent >= 0}
							>{NumberFormat(user.real_client_value[timeperiod].real_net_win_percent, true)}%</td
						>
					{/each}
				</tr>
			</table>
		</div>
	</div>
{/if}
